import React, {useEffect, useState} from 'react';
import {useSelector} from 'react-redux';
import { useNavigate, useParams } from "react-router-dom";

import Typography from "@mui/material/Typography";
import {Flex} from "reflexbox";
import secondsToHMSformat from "../helpers/secondsToHMSformat"
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import PageHeader from "../gamePlayComponents/PageHeader";
import Button from "@mui/material/Button";
import {FEEDBACK, HOME} from "../helpers/routes";
import { APP_STORE_URL, PLAY_STORE_URL } from "../../pages/Feedback";
import { clearUserCurrentTeamId } from "../../helpers/dbFunctions";
import Tipping from "../../pages/Tipping";
import { courseFriendlyName} from "../courseContent/courseObjects";
import {getTimeAndScore} from "../../helpers/gameUtils";
import ShareButton from "./ShareButton";
import {nativeApi} from '../expo/NativeAPI';
import DetailedQuestionBreakdown from "./DetailedQuestionBreakdown";
import Leaderboard, {ordinal_suffix_of} from "./Leaderboard";
import CircularProgress from "@mui/material/CircularProgress";
import { useTheme } from '@mui/material/styles';


export const ScoreSummaryCard = (props) => (<Card style={{marginBottom: '16px'}}>
  <CardContent>
    <Flex style={{flexDirection: 'column'}}>
      <Typography variant={'h6'} style={{textAlign: 'center', margin: '0 16px 8px'}}
                  color={'primary'}>{props?.title}</Typography>
      {props.children}
    </Flex>
  </CardContent>
</Card>);


const ScoreSummary = (props) => {
  const theme = useTheme();
  let navigate = useNavigate();
  const {course} = useParams();
  const [rank, setRank] = useState(null);
  const uid = useSelector((state) => state.user?.uid);
  const platform = useSelector((state) => state.platform?.platform);

  useEffect(() => {
    setTimeout (()=> {
      nativeApi.requestAppReview()
    }, 25000);
  }, []);

  const questionHistory = useSelector((state) => state.team?.teamDetails?.questions) || {};
  const courseName = course || null;
  const friendlyCourseName = courseName && courseFriendlyName(courseName);

  const { pointsFromQs , completedQuestionTime, questionsCorrect , totalQuestions } = getTimeAndScore(questionHistory, courseName);
  const timeBonus = completedQuestionTime ? Math.max(0, Math.min(1, 1 / completedQuestionTime)) : 0;
  const totalPoints = pointsFromQs + timeBonus;

  return (
    <>
      <PageHeader
        title={'Results!'}
        goHome
        onGoHome={() => {
          clearUserCurrentTeamId(uid);
          navigate(HOME);
        }}
      />
      <Typography variant={'subtitle2'} style={{textAlign: 'center', margin: '0 16px 8px'}} color={'primary'}>
        For the {friendlyCourseName} course
      </Typography>
      <ScoreSummaryCard title={'Total Score'}>
        <Flex w={1}  style={{justifyContent: 'space-around', textAlign: 'center'}}>
          <Flex id={'rank'} style={{flexDirection: 'column', justifyContent: 'center', width: '100%'}}>
            <Typography> Rank </Typography>
            <Flex style={{justifyContent: 'center'}}>
              {rank ? <>
                <Typography>{rank}</Typography>
                <Typography variant={'caption'}>{ordinal_suffix_of(rank)}</Typography>
              </> : <CircularProgress size={20}/>}
            </Flex>
          </Flex>
          <Flex style={{justifyContent: 'center', width: '100%'}}>
          <Flex id={'circle'} style={{
            height: '110px',
            width: '110px',
            marginBottom: '16px',
            backgroundColor: theme.palette.primary.main,
            borderRadius: '50%',
            alignItems: 'center',
            justifyContent: 'center'
          }}>
            <Typography variant="h4" sx={{ textAlign: 'center', color: theme.palette.primary.contrastText }}>
              {Math.floor(totalPoints)}{' '}
            </Typography>
          </Flex>
          </Flex>
          <Flex id={'time'} style={{flexDirection: 'column', justifyContent: 'center', width: '100%'}}>
            <Typography> Time </Typography>
            <Typography> {secondsToHMSformat(completedQuestionTime)}</Typography>
          </Flex>
        </Flex>

        <Typography style={{textAlign: 'center'}}>You got {questionsCorrect} out of {totalQuestions} questions correct!</Typography>
      </ScoreSummaryCard>

      <ScoreSummaryCard title={'Think your friends can beat you?'}>
        <Typography variant={'body2'} style={{textAlign: 'center', marginBottom: '8px'}}>
          Challenge them and find out!
        </Typography>
        <ShareButton friendlyCourseName={friendlyCourseName} questionsCorrect={questionsCorrect}
                     totalQuestions={totalQuestions} totalScore={totalPoints} time={completedQuestionTime}
        />
      </ScoreSummaryCard>

      {/*<ScoreSummaryCard title={'Time Breakdown:'}>*/}
        {/*<Typography>Total time: {secondsToHMSformat(completedQuestionTime)}</Typography>*/}
        {/*<Typography>Time left on the clock: {secondsToHMSformat(remainingTime)}</Typography>*/}
        {/*<Typography>Points from time: {pointsFromTime}</Typography>*/}
        {/*<Typography variant={'caption'} style={{paddingTop: '8px'}}>You earn {pointsPerMinuteFasterThanCountDown} point*/}
          {/*per minute faster than the countdown timer (starts*/}
          {/*at {secondsToHMSformat(countDownStartNum, 'plaintext')}).</Typography>*/}
      {/*</ScoreSummaryCard>*/}

      <ScoreSummaryCard title={'Leaderboard'}>
        <Leaderboard courseName={courseName} setRank={(el)=>setRank(el)}/>
      </ScoreSummaryCard>

      <Tipping postGame/>

      <ScoreSummaryCard title={'Tell us what you thought!'}>
        <Flex>
        <Button
          variant={'outlined'}
          color={'primary'}
          style={{width: '100%'}}
          onClick={() => window.open(platform === 'ios' ? APP_STORE_URL : platform === 'android' ? PLAY_STORE_URL : APP_STORE_URL, '_blank')}
        >
          Leave an app review
        </Button>
          <div style={{width: '0px', margin: '8px'}}/>
          <Button variant={'outlined'} color={'primary'} style={{width: '100%'}} onClick={() => navigate(FEEDBACK)}> Contact us </Button>
        </Flex>
      </ScoreSummaryCard>

      <ScoreSummaryCard title={'Question Breakdown:'}>
        <Typography>Questions
          correct: {questionsCorrect} of {totalQuestions} ({Math.round(questionsCorrect / totalQuestions * 100)}%)</Typography>
        <Typography>Points from questions: {pointsFromQs}</Typography>
      </ScoreSummaryCard>

      <ScoreSummaryCard title={'Detailed Question Breakdown:'}>
        <DetailedQuestionBreakdown courseName={courseName}/>
      </ScoreSummaryCard>

      <Button variant={'contained'} color={'primary'} style={{width: '100%', marginTop: '16px', marginBottom: '24px'}}
              onClick={() => {
                clearUserCurrentTeamId(uid);
                navigate(HOME);
              }}>
        Return to main menu
      </Button>
    </>
  )
};

export default ScoreSummary;
